import styled from "styled-components"
import { StyledAppContainer } from "pages/app/styles/StyledAppContainer"

export const GridDisplay = styled(StyledAppContainer)``
